import { Component, inject, signal } from '@angular/core';
import { ThemePreference, ThemeService } from '@services/theme.service';

interface ToggleOption {
  value: ThemePreference;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss'],
})
export class ThemeToggleComponent {
  protected readonly themeService = inject(ThemeService);

  protected readonly options = signal<ToggleOption[]>([
    { value: 'light', label: 'Light theme', icon: 'fa-solid fa-sun' },
    { value: 'system', label: 'Follow system theme', icon: 'fa-solid fa-desktop' },
    { value: 'dark', label: 'Dark theme', icon: 'fa-solid fa-moon' },
  ]).asReadonly();

  protected select(value: ThemePreference): void {
    this.themeService.setPreference(value);
  }
}
